import loadable from '@loadable/component';
import { withLazyLoad } from '~spa/Components/LazyLoad/LazyLoad';

const BetFeedWidget = loadable(
    () => import(/* webpackChunkName: "betfeedwidget" */ './BetFeedWidget')
);
const PLACEHOLDER_HEIGHT = 100;

export default withLazyLoad(PLACEHOLDER_HEIGHT)(BetFeedWidget);
